import { motion } from 'framer-motion'
import Header from '../components/Header'

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.4, delay },
})

const experience = [
  {
    role: 'Growth Engineer',
    company: 'Empresa B2B · setor de R$350M ARR',
    period: 'Jul/2025 · atual',
    promoted: 'promovido Jan/2026 (dev → Growth Engineer)',
    bullets: [
      'Sistema de fallback de formulários em 48h: recuperou 4.200 leads e R$200k+ em receita salva',
      'GEO em 280 landing pages: llms.txt, Content-Signal e JSON-LD para indexação por GPTBot, ClaudeBot e PerplexityBot. Primeiro no setor B2B brasileiro. Projeção de R$10M+ em receita orgânica influenciável via IA search em 12 meses.',
      'PageSpeed mobile 47,8 → 89 em 9 sites WordPress (+41pts em 2 semanas, 4 fases de engenharia)',
      'Race condition que corrompeu 11.007 leads resolvida com SQL de reconciliação e locks de transação',
      'Pipeline B.I.: Meta Ads API + Google Ads API (9 contas) → n8n → BigQuery → dashboards diários',
    ],
    tags: ['n8n', 'BigQuery', 'Meta Ads API', 'Google Ads API', 'PHP', 'WordPress', 'Redis'],
  },
  {
    role: 'Growth Engineer',
    company: 'Agência de Performance · stealth',
    period: '2024 · atual',
    promoted: null,
    bullets: [
      'De R$0 a R$40k MRR em 18 meses. 2 pessoas. Zero investidor. R$9M+ em tráfego pago administrado.',
      '40+ LPs construídas e otimizadas para clientes: 50k+ visitas orgânicas mensais geradas',
      'Relatórios e dashboards automáticos: Meta Ads + Google Ads → BigQuery → análise semanal e mensal por cliente. Processos internos mapeados em SOP.',
      'AIOS: framework de 20+ agentes Claude Code especializados em produção (dev, growth, cyber, n8n, cfo)',
      'SDL: pipeline de roteamento, enriquecimento e qualificação de leads por IA. 4k+ leads distribuídos com contexto.',
    ],
    tags: ['Claude Code', 'Docker', 'Supabase', 'n8n', 'TypeScript', 'React'],
  },
  {
    role: 'Desenvolvedor',
    company: 'Vc.Ecom · Uberlândia, MG',
    period: 'Dez/2024 · Jun/2025',
    promoted: null,
    bullets: [
      'Sistema SDR com n8n + Python: roteamento automático de leads por score, desqualificação e distribuição para o time de vendas',
      'Fluxos de recuperação de carrinho abandonado com múltiplos toques. Integração de gateways de pagamento com fallback automático.',
      'Pipeline de scoring de leads com IA: PostgreSQL + Redis para baixa latência, classificação por perfil e intenção de compra',
    ],
    tags: ['Python', 'n8n', 'PostgreSQL', 'Redis', 'GCP'],
  },
  {
    role: 'Desenvolvedor',
    company: 'Use Lady · Uberlândia, MG',
    period: 'Out/2022 · Abr/2023',
    promoted: null,
    bullets: [
      'Loja Shopify do zero: customização de tema, catálogo de produtos, checkout e experiência mobile-first',
      'Integração de gateways de pagamento (cartão, Pix, boleto) com experiência de checkout otimizada',
      'CRM e automações de marketing: recuperação de carrinho, sequências de e-mail e segmentação de clientes por comportamento',
    ],
    tags: ['Shopify', 'HTML/CSS', 'E-commerce', 'CRM'],
  },
  {
    role: 'Freelancer · Web & Automações',
    company: 'Autônomo · Uberlândia, MG',
    period: '2022 · atual',
    promoted: null,
    bullets: [
      'LPs de alta conversão e lojas virtuais em WordPress para clientes PME. Briefing a go-live em até 7 dias.',
      'Automações n8n: qualificação de leads por WhatsApp, e-mail marketing sequencial, postagem automática em redes sociais e recuperação de carrinho',
      'Integração de plataformas: CRM, ERP, gateways de pagamento e APIs de WhatsApp via webhooks n8n',
    ],
    tags: ['WordPress', 'n8n', 'HTML/CSS', 'WhatsApp API', 'Make'],
  },
]

const projects = [
  {
    name: 'AIOS: AI Operating System',
    status: 'produção',
    metric: '20+ agentes',
    desc: 'Framework de agentes Claude Code especializados para orquestração de workflows GTM: enriquecimento de leads, geração de copy, análise de performance. Stack: n8n queue mode + Supabase como fonte de verdade.',
    tags: ['Claude API', 'TypeScript', 'n8n', 'Supabase'],
    href: null,
  },
  {
    name: 'WP-AUDIT + mu-plugins de hardening',
    status: 'produção · 9 servidores',
    metric: '9 sites',
    desc: 'Toolkit bash de segurança WordPress em escala: detecta webshells, backdoors MySQL, PHP em uploads, divergências de checksum. Stack completo de hardening (SSH, UFW, fail2ban, WAF) em produção.',
    tags: ['Bash', 'PHP', 'MySQL', 'Linux'],
    href: null,
  },
  {
    name: 'SDL: Sistema de Roteamento de Leads',
    status: 'agência · stealth',
    metric: '4k leads',
    desc: 'Pipeline de roteamento, qualificação e enriquecimento de leads via IA. Coleta, higieniza, prioriza e distribui leads para o time comercial com contexto completo (empresa, cargo, intenção).',
    tags: ['n8n', 'Supabase', 'Python', 'Claude API'],
    href: null,
  },
  {
    name: 'matheusedson.com',
    status: 'ao vivo',
    metric: '21 segredos',
    desc: 'SPA React + Vite com 21 easter eggs educativos em cada camada da web (Console, Cookie, localStorage, IndexedDB, Headers, etc). Caçada gamificada na /stats. Pipeline próprio de analytics com Cloudflare Workers + Supabase.',
    tags: ['React', 'TypeScript', 'Cloudflare Workers', 'Supabase', 'Docker'],
    href: 'https://matheusedson.com',
  },
  {
    name: 'Laxtro: SaaS de conteúdo white label',
    status: 'em construção · 2026',
    metric: 'DNA → pauta → roteiro → post',
    desc: 'SaaS white label para agências de conteúdo. Pipeline: DNA editorial da marca → pautas → roteiros → assets visuais (HTML→PNG) → captions por plataforma. Multi-tenant com cron mensal e geração por IA. React + Supabase.',
    tags: ['React', 'TypeScript', 'Supabase', 'n8n'],
    href: null,
  },
  {
    name: 'ETL de APIs de mídia paga',
    status: 'produção',
    metric: 'Meta + Google → BigQuery',
    desc: 'Pipeline Python que coleta dados da Meta Ads API e Google Ads API (9 contas), transforma e carrega no BigQuery. Dashboards de CPL, ROAS e CAC por segmento rodando em produção diariamente.',
    tags: ['Python', 'BigQuery', 'Meta Ads API', 'Google Ads API', 'n8n'],
    href: null,
  },
  {
    name: 'Transcribe: video-to-text em lote',
    status: 'open source',
    metric: 'MP4 → Whisper → TXT',
    desc: 'Pipeline Python para transcrição em lote de vídeos: extração de áudio com FFmpeg, transcrição local via Whisper (sem custo de API) e manifest JSON com rastreio de origem, tamanho e contagem de palavras.',
    tags: ['Python', 'FFmpeg', 'Whisper', 'Node.js'],
    href: 'https://github.com/MatheusEdson/Transcribe-',
  },
  {
    name: 'Chronos RPI: controle de acesso facial',
    status: 'contribuição',
    metric: 'Raspberry Pi + ControlID iDFaceMax',
    desc: 'Middleware Node.js que integra dispositivos ControlID (iDFaceMax) com webapp via túnel Cloudflare. Reconhecimento facial, cadastro anti-duplicata, descoberta automática de dispositivos em rede. Pocketbase como banco de dados.',
    tags: ['Node.js', 'Pocketbase', 'Cloudflare Tunnel', 'Raspberry Pi'],
    href: 'https://github.com/jimv-dev/chronos-rpi',
  },
]

const stack = [
  { cat: 'Linguagens',    items: ['Python', 'TypeScript', 'SQL', 'Bash', 'PHP'] },
  { cat: 'Frontend',      items: ['React', 'Vite', 'Framer Motion', 'WordPress'] },
  { cat: 'Backend / Data',items: ['n8n', 'Supabase', 'PostgreSQL', 'Redis', 'BigQuery'] },
  { cat: 'Infra',         items: ['Docker', 'Traefik', 'nginx', 'Linux VPS', 'Cloudflare Workers'] },
  { cat: 'Analytics',     items: ['GA4', 'GTM', 'Microsoft Clarity', 'Meta Ads API', 'Google Ads API'] },
  { cat: 'IA',            items: ['Claude Code', 'Claude API', 'AIOS framework', 'LLM pipelines'] },
]

const metrics = [
  { value: '60k', label: 'leads gerados em 2 anos' },
  { value: 'R$500k+', label: 'em receita salva e recuperada' },
  { value: 'R$9M+', label: 'em tráfego pago administrado' },
  { value: '90+', label: 'CWV médio em 9 sites WordPress' },
  { value: '47', label: 'workflows n8n em produção' },
]

const activities = [
  'GRVA: Grupo de Realidade Virtual e Aumentada (UFU)',
  'GIIA: Inteligência Artificial Interdisciplinar (UFU)',
  'XABUTRONICS: Líder de projeto (garra robótica)',
]

const languages = [
  { name: 'Português', level: 'Nativo' },
  { name: 'Inglês', level: 'Fluente' },
  { name: 'Espanhol', level: 'Avançado' },
]

export default function Curriculo() {
  return (
    <>
      <Header />
      <main style={{ maxWidth: 820, margin: '0 auto', padding: '3rem 1.5rem 6rem' }}>

        {/* Hero */}
        <motion.div {...fade(0)} style={{ marginBottom: '2.5rem' }}>
          <div className="no-print" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <p style={{ fontSize: '0.75rem', color: 'var(--muted)', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
              Currículo
            </p>
            <button
              onClick={() => window.print()}
              style={{
                fontSize: '0.75rem',
                padding: '0.4rem 0.9rem',
                border: '1px solid var(--border-strong)',
                borderRadius: 5,
                color: 'var(--muted)',
                cursor: 'pointer',
                fontFamily: "'JetBrains Mono', monospace",
                letterSpacing: '0.06em',
                transition: 'color 0.15s, border-color 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.color = 'var(--text)'; e.currentTarget.style.borderColor = 'var(--text)' }}
              onMouseLeave={e => { e.currentTarget.style.color = 'var(--muted)'; e.currentTarget.style.borderColor = 'var(--border-strong)' }}
            >
              ↓ PDF
            </button>
          </div>
          <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 700, letterSpacing: '-0.03em', lineHeight: 1.1, marginBottom: '0.5rem' }}>
            Matheus Edson Moreira Linhares
          </h1>
          <p style={{ color: 'var(--text)', fontSize: '1.05rem', marginBottom: '0.6rem' }}>
            Growth Engineer · 21 anos · Uberlândia, MG
          </p>
          <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', fontSize: '0.85rem', color: 'var(--muted)' }}>
            <a href="mailto:linharesmatheus29@gmail.com" style={{ color: 'inherit' }}>linharesmatheus29@gmail.com</a>
            <span>·</span>
            <span>+55 34 99651-0731</span>
            <span>·</span>
            <a href="https://matheusedson.com" style={{ color: 'inherit' }}>matheusedson.com</a>
          </div>
        </motion.div>

        {/* Metrics */}
        <motion.div {...fade(0.05)} style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
          gap: '1px',
          background: 'var(--border)',
          border: '1px solid var(--border)',
          borderRadius: 10,
          overflow: 'hidden',
          marginBottom: '3rem',
        }}>
          {metrics.map(m => (
            <div key={m.label} style={{ background: 'var(--bg2)', padding: '1.25rem 1rem' }}>
              <div style={{ fontSize: '1.4rem', fontWeight: 800, letterSpacing: '-0.03em', marginBottom: '0.25rem' }}>{m.value}</div>
              <div style={{ fontSize: '0.7rem', color: 'var(--muted)', lineHeight: 1.4 }}>{m.label}</div>
            </div>
          ))}
        </motion.div>

        {/* Sobre */}
        <motion.section {...fade(0.08)} style={{ marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '0.7rem', color: 'var(--muted)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '1rem' }}>
            Sobre
          </h2>
          <p style={{ color: 'var(--muted)', fontSize: '0.92rem', lineHeight: 1.7 }}>
            Growth Engineer com foco em sistemas de receita. Construo a infraestrutura que liga gasto em mídia a faturamento real: 60k leads gerados, R$500k+ em receita salva, R$9M+ em tráfego administrado. Stack: n8n queue mode, BigQuery, Claude Code, Docker. Agência de performance própria (R$40k MRR) e empresa B2B de R$350M/ano. Engenharia da Computação na UFU.
          </p>
        </motion.section>

        {/* Experience */}
        <motion.section {...fade(0.1)} style={{ marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '0.7rem', color: 'var(--muted)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '1.25rem' }}>
            Experiência
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
            {experience.map((exp, i) => (
              <div key={i} style={{ paddingBottom: '1.5rem', borderBottom: i < experience.length - 1 ? '1px solid var(--border)' : 'none' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '1rem', flexWrap: 'wrap', marginBottom: '0.3rem' }}>
                  <p style={{ fontWeight: 600, fontSize: '1.05rem' }}>{exp.role}</p>
                  <span style={{ fontSize: '0.78rem', color: 'var(--muted)', whiteSpace: 'nowrap' }}>{exp.period}</span>
                </div>
                <p style={{ color: 'var(--muted)', fontSize: '0.85rem', marginBottom: exp.promoted ? '0.2rem' : '0.9rem' }}>{exp.company}</p>
                {exp.promoted && (
                  <p style={{ fontSize: '0.72rem', color: '#4ade80', marginBottom: '0.9rem', fontStyle: 'italic' }}>{exp.promoted}</p>
                )}
                <ul style={{ listStyle: 'none', padding: 0, marginBottom: '1rem' }}>
                  {exp.bullets.map((b, j) => (
                    <li key={j} style={{ color: 'var(--text)', fontSize: '0.87rem', lineHeight: 1.65, paddingLeft: '1.1rem', position: 'relative', marginBottom: '0.4rem' }}>
                      <span style={{ position: 'absolute', left: 0, color: 'var(--muted)' }}>›</span>
                      {b}
                    </li>
                  ))}
                </ul>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem' }}>
                  {exp.tags.map(tag => (
                    <span key={tag} style={{ fontSize: '0.7rem', padding: '0.2rem 0.55rem', borderRadius: 4, background: 'var(--bg3)', color: 'var(--muted)', border: '1px solid var(--border)' }}>{tag}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </motion.section>

        {/* Projects */}
        <motion.section {...fade(0.15)} style={{ marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '0.7rem', color: 'var(--muted)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '1.25rem' }}>
            Projetos
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {projects.map((p, i) => (
              <div key={i} style={{
                padding: '1.25rem 1.5rem',
                border: '1px solid var(--border)',
                borderRadius: 10,
                background: 'var(--bg2)',
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem', marginBottom: '0.4rem', flexWrap: 'wrap' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap' }}>
                    <span style={{ fontWeight: 600, fontSize: '0.95rem' }}>{p.name}</span>
                    {p.href && (
                      <a href={p.href} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.72rem', color: 'var(--muted)', textDecoration: 'none' }}>↗</a>
                    )}
                    <span style={{ fontSize: '0.65rem', color: '#4ade80', background: 'rgba(74,222,128,0.1)', padding: '0.1rem 0.4rem', borderRadius: 3, border: '1px solid rgba(74,222,128,0.2)' }}>{p.status}</span>
                  </div>
                  <span style={{ fontSize: '0.72rem', color: 'var(--muted)', fontFamily: 'monospace' }}>{p.metric}</span>
                </div>
                <p style={{ color: 'var(--muted)', fontSize: '0.85rem', lineHeight: 1.6, marginBottom: '0.75rem' }}>{p.desc}</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem' }}>
                  {p.tags.map(tag => (
                    <span key={tag} style={{ fontSize: '0.66rem', padding: '0.15rem 0.45rem', borderRadius: 3, background: 'var(--bg3)', color: 'var(--muted2)', border: '1px solid var(--border)' }}>{tag}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </motion.section>

        {/* Stack */}
        <motion.section {...fade(0.2)} style={{ marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '0.7rem', color: 'var(--muted)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '1.25rem' }}>
            Stack
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {stack.map(({ cat, items }) => (
              <div key={cat} style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: '0.6rem', alignItems: 'flex-start' }}>
                <span style={{ fontSize: '0.75rem', color: 'var(--muted2)', paddingTop: '0.3rem' }}>{cat}</span>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem' }}>
                  {items.map(item => (
                    <span key={item} style={{ fontSize: '0.74rem', padding: '0.22rem 0.6rem', borderRadius: 5, background: 'var(--bg3)', color: 'var(--muted)', border: '1px solid var(--border)' }}>{item}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </motion.section>

        {/* Education + Languages */}
        <motion.section {...fade(0.25)} style={{ marginBottom: '3rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
            <div>
              <h2 style={{ fontSize: '0.7rem', color: 'var(--muted)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '1rem' }}>
                Formação
              </h2>
              <p style={{ fontWeight: 600, fontSize: '0.95rem', marginBottom: '0.2rem' }}>Engenharia da Computação</p>
              <p style={{ color: 'var(--muted)', fontSize: '0.82rem', marginBottom: '0.4rem' }}>Universidade Federal de Uberlândia · UFU</p>
              <p style={{ fontSize: '0.72rem', color: 'var(--muted2)', marginBottom: '0.9rem' }}>2024 · conclusão 06/2028</p>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {activities.map(a => (
                  <li key={a} style={{ fontSize: '0.78rem', color: 'var(--muted)', lineHeight: 1.7, paddingLeft: '0.9rem', position: 'relative' }}>
                    <span style={{ position: 'absolute', left: 0 }}>·</span>
                    {a}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 style={{ fontSize: '0.7rem', color: 'var(--muted)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '1rem' }}>
                Idiomas
              </h2>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {languages.map(l => (
                  <div key={l.name} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem' }}>
                    <span>{l.name}</span>
                    <span style={{ color: 'var(--muted)' }}>{l.level}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </motion.section>

        {/* Contact */}
        <motion.section {...fade(0.3)}>
          <h2 style={{ fontSize: '0.7rem', color: 'var(--muted)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '1.25rem' }}>
            Contato
          </h2>
          <div style={{ display: 'flex', gap: '0.7rem', flexWrap: 'wrap' }}>
            <a
              href="mailto:linharesmatheus29@gmail.com"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.65rem 1.3rem', background: 'var(--text)', color: '#080808', borderRadius: 8, fontWeight: 600, fontSize: '0.875rem', textDecoration: 'none' }}
            >
              Mandar mensagem
            </a>
            <a
              href="https://www.linkedin.com/in/matheus-edson-linhares-4620b82b1/"
              target="_blank" rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.65rem 1.3rem', border: '1px solid var(--border)', borderRadius: 8, fontSize: '0.875rem', color: 'var(--muted)', textDecoration: 'none' }}
            >LinkedIn</a>
            <a
              href="https://github.com/MatheusEdson"
              target="_blank" rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.65rem 1.3rem', border: '1px solid var(--border)', borderRadius: 8, fontSize: '0.875rem', color: 'var(--muted)', textDecoration: 'none' }}
            >GitHub</a>
          </div>
        </motion.section>

      </main>
    </>
  )
}
